import styled from 'vue-styled-components'
import { breakpointStyle } from '../../utils'

let propsLink = {
  active: Boolean
}

const StyledLink = styled('a', propsLink)`
  color: ${props => props.theme.colors.gray};
  font-size: .875rem;
  font-weight: ${props => props.theme.fontWeight.semiBold};
  text-decoration: none;
  
  &:hover {
    color: ${props => props.active ? '#000' : '#fff'};
  }
`

const StyledLinkPhone = styled(StyledLink)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: auto;
  
  ${props => breakpointStyle(props.theme.media.tablet, `
    position: relative;
    left: initial;
    margin: initial;
    transform: translateX(0);
  `)}
  
  ${props => breakpointStyle(props.theme.media.desktop, `
    margin-right: 31px;
    order: 3;
    `)}
`

const StyledLinkEmail = styled(StyledLink)`
  display: none;
  
  ${props => breakpointStyle(props.theme.media.tablet, `
    display: block;
  `)}
  
  ${props => breakpointStyle(props.theme.media.desktop, `
    order: 2;
    margin-right: 46px;
  `)}
`

const StyledSocials = styled.div`
  order: 4;
  display: none;
  
  ${props => breakpointStyle(props.theme.media.desktop, `
    display: block;
  `)}
`

export {
  StyledLinkPhone,
  StyledLinkEmail,
  StyledSocials
}



// WEBPACK FOOTER //
// ./src/components/Header/StyledHeader.js